import { digitsOnly } from 'lib/phone'

/** Absent means undefined or the null GraphQL returns for an empty field; both format to undefined. */
export function formatPhoneNumber(phoneNumber?: string | null): string | undefined {
  return phoneNumber == null
    ? undefined
    : digitsOnly(phoneNumber).replace(/([0-9]{3})([0-9]{3})([0-9]{4})/, `($1) $2-$3`)
}

/**
 * Digits-only last ten, for comparing two phone numbers that may be stored in
 * different formats. Mirrors the key the API's OptOut.normalizeKey builds.
 */
export function normalizePhoneKey(phoneNumber?: string | null): string {
  return digitsOnly(phoneNumber ?? ``).slice(-10)
}

/** Display a number as "(207) 555-0142 - Main Line", or just the formatted phone when it has no label. */
export function formatPhoneWithLabel(phoneNumber?: string | null, label?: string | null): string {
  const phone = formatPhoneNumber(phoneNumber) || phoneNumber || ``
  return label ? `${phone} - ${label}` : phone
}
